export class BuildDate { public static readonly stamp = '1717595161645'; }